module.exports = __webpack_public_path__ + "img/7a64d058-8174-4ec5-b54d-c9467359fc97.83474a3b.png";